export const ROUTES = {
  home: "/",
  Privacynotice: "/privacy-notice",
  Termsconditions: "/site-terms-Conditions"
  
};
